<div [formGroup]="form" *ngIf="formField.scope === 'GLOBAL' || formField.scope === 'LOCAL' || formField.real === false">
    <label [matTooltip]="formField.description">{{ formField.name }} <span
        style="color: red; position: relative; top: 3px;"
        *ngIf="formField.required">*</span></label>
    <div class="flex-100" >
        <div *ngIf="formField.type === 'TEXT'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
                       (focusout)="(formField.tag === 'TAG' || formField.jsonProperty === 'defaultTag') ?
                       pickValidationFunction(formField) : null" class="flex-100"
                >
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'NUM'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <input matInput [formControlName]="formField.jsonProperty" [type]="'number'"
                       (focusout)="numberValidation(formField.jsonProperty)" class="flex-100"
                >
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'BOOL'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
                    <mat-option *ngFor="let option of formField.options"
                                [value]="option.value" [disabled]="selectedFeatureScope === 'Viewer'">{{ option.label }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'TEXTAREA'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <textarea matInput
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="3"
                          [formControlName]="formField.jsonProperty" class="flex-100"

                >
                </textarea>
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'SELECT'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
                    <mat-option *ngFor="let option of formField.options"
                                [value]="option.value" [disabled]="selectedFeatureScope === 'Viewer'">{{ option.label }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'MULTI_SELECT'"
             [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()"
             (mouseover)="selectedFeatureScope === 'Viewer' ? setTooltipToFieldValue(formField.jsonProperty) : null"
             [matTooltip]="overrideTooltip | async">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <mat-select [formControlName]="formField.jsonProperty"
                            multiple class="flex-100">
                    <mat-option *ngFor="let option of formField.options as Array"
                                [value]="option.value" [disabled]="selectedFeatureScope === 'Viewer'">{{ option.label }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'IMAGE'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
                       (focusout)="imageValidation(formField.jsonProperty)" class="flex-100"
                >
            </mat-form-field>
        </div>
    </div>
    <div class="action-buttons-container">
        <div class="stacked-icons">
            <div *ngIf="formField.scope === 'LOCAL' && !formField.required && !(hasParentOverride$ | async)">
                <button
                    class="remove-attribute"
                    mat-icon-button
                    matTooltip="Remove Attribute"
                    tabIndex="-1"
                    type="button"
                    (click)="handleRemoveLocalAttribute(formField)"
                    *ngIf="selectedFeatureScope === 'Global'"
                >
                    <mat-icon>delete_forever</mat-icon>
                </button>
                <span *ngIf="formField.jsonProperty === 'defaultTag'"
                      class="material-symbols-outlined default-tag-tooltip">
                    <mat-icon matTooltip="First item will become Default Tag if selected value is disabled">
                        info
                    </mat-icon>
                </span>
            </div>
            <div *ngIf="formField.scope === 'LOCAL' && (hasParentOverride$ | async)">
                <span class="material-symbols-outlined required-local-attribute">
                    <mat-icon [matTooltip]="'This dynamic attribute has an override at the parent level, ' +
                    (parentOverride | async)">info</mat-icon>
                </span>
            </div>
            <div *ngIf="formField.scope === 'LOCAL' && formField.required && formField.jsonProperty === 'modifierType'">
                <span class="material-symbols-outlined required-local-attribute">
                    <mat-icon matTooltip="This is a required attribute for Dressing, Condiments, Ingredients, and Sauces.">info</mat-icon>
                </span>
            </div>
        </div>
        <div class="list-icon" *ngIf="selectedFeatureScope === 'Global'">
            <button
                mat-icon-button
                matTooltip="View values for {{ formField.name }} by location"
                tabIndex="-1"
                type="button"
                (click)="openViewOverridesDialog()"
            >
                <mat-icon>list</mat-icon>
            </button>
        </div>
    </div>
</div>
